import styles from './Socials.module.scss';

import React from 'react';
import Link from 'next/link';

import { useRouter } from 'next/router';

type SocialLoginProps = {
  type?: 'phone' | 'email';
};

const SocialLogin: React.FC<SocialLoginProps> = ({ type }) => {
  const { query } = useRouter();

  return (
    <div className={styles.buttonGroup}>
      {type === 'email' ? (
        <div className={styles.optionButton}>
          <Link
            href={{
              pathname: '/login',
              query: {
                ...query,
                type: 'email'
              }
            }}
            className={styles.phone}
            data-test="btn-email-login"
          >
            <img src="/img/icons/envelope.svg" />
          </Link>
        </div>
      ) : (
        <div className={styles.optionButton}>
          <Link
            href={{
              pathname: '/login',
              query: {
                ...query,
                type: 'phone'
              }
            }}
            className={styles.phone}
            data-test="img-phone"
          >
            <img src="/img/icons/phone.svg" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default SocialLogin;
